import routes from 'brand/app/components/APIRouter/routes';

import {RouteAPI} from './IAPIRouter';

/**
 * Represents Route Manager
 */
class RouteManager {
	private routes: Array<RouteAPI>;
	private systemPathnames: RegExp[] = [
		/\/mobify\/bundle\/*/
	];
	/**
	 * @constructor
	 */
	constructor() {
		// Load routes from brand level
		this.routes = routes as Array<RouteAPI>;
	}

	/**
	 * Returns route by action
	 * @param {string} action action
	 * @returns {RouteAPI} route
	 */
	getRoute(action: string): RouteAPI {
		return action
			? this.routes.find((route) => {
				return action.match(new RegExp(route.action));
			  })
			: this.routes[this.routes.length - 1];
	}

	/**
	 * Checks if pathname belongs to system pathnames
	 * @param {String} pathname - pathname
	 * @returns {Boolean} - if pathname belongs to system pathnames
	 */
	isSystemPathname(pathname: string): boolean {
		return this.systemPathnames.some((systemPathname) => {
			return pathname.match(systemPathname);
		});
	};
}

export default new RouteManager();
